// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh4[data-v-d7f2a336] {\n  font-size: 13px;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
